import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { WorkInfoModel } from '../../models/work-info/work-info.model';

export interface WorkInfoState {
  workInfo: WorkInfoModel;
}

export const createInitialState = (): WorkInfoState => ({
  workInfo: {} as WorkInfoModel,
});

// @Injectable({
//     providedIn: 'root'
// })
// @StoreConfig({name: 'work-info'})
export class WorkInfoStore extends Store<WorkInfoState> {
  constructor(storeName: string) {
    super(createInitialState(), { name: storeName, idKey: 'work-info' });
  }
}
